import { createReducer, Action, on } from '@ngrx/store';
import {
    createFormGroupState,
    onNgrxForms,
    updateGroup,
    validate,
    onNgrxFormsAction,
    SetValueAction,
    wrapReducerWithFormStateUpdate,
    setValue,
} from 'ngrx-forms';
import {
    notEqualTo,
    required,
} from 'ngrx-forms/validation';
import { AddressModel } from '@ifaa-components/ui-components';
import { GetGenderOptionsResponseAction, ResetDataSavedAction, SaveDetailsRequestAction, SaveDetailsResponseAction, SetDataFromInitialDataStepAction, SetDetailsErrorAction, UpdateDetailsFieldRequestAction, UpdateDetailsFieldResponseAction } from './actions';
import { IDetailsState } from './state';
import { PersonalDetailsModel } from 'src/app/model/member-details.model';

const formName = 'details';

const defaultState: IDetailsState = {
    form: createFormGroupState(formName, new PersonalDetailsModel()),
    dataSaved: false,
    genders:null,
    hasError:false,
    isLoading:false
};

const validateDetailsData = updateGroup<PersonalDetailsModel>({
    firstName: validate(required),
    mobile: validate(required),
    lastName: validate(required),
    dob: validate(required),
    gender: validate(required, notEqualTo(0)),
    address: updateGroup<AddressModel>({
        lineOne: validate(required),
        state: validate(required),
        country: validate(required),
    }),
});

const reducer = createReducer(
    defaultState,
    onNgrxForms(),
    onNgrxFormsAction(SetValueAction, (state, _action) => {
        return state;
    }),
    on(SetDataFromInitialDataStepAction, (state, { data }) => {
        return {
            ...state,
            form: updateGroup<PersonalDetailsModel>(state.form, { firstName: setValue(data.firstName), lastName: setValue(data.lastName) })
        }
    }),
    on(GetGenderOptionsResponseAction, (state, {genders}) => {
        return {
            ...state,
            genders
        }
    }),
    on(SaveDetailsRequestAction, (state) => {
        return {
            ...state,
            isLoading:true
        }
    }),
    on(SaveDetailsResponseAction, (state) => {
        return {
            ...state,
            dataSaved:true,
            isLoading:false
        }
    }),
    on(ResetDataSavedAction, (state) => {
        return {
            ...state,
            dataSaved:false
        }
    }),
    on(SetDetailsErrorAction, (state) => {
        return{
            ...state,
            hasError:true
        }
    }),
    on(UpdateDetailsFieldResponseAction, (state) => {
        return {
            ...state,
            hasError:false,
            isLoading:false
        }
    }),
    on(UpdateDetailsFieldRequestAction,(state) => {
        return {
            ...state,
            isLoading:true
        }
    })
);

const editDetailsDataFormState = wrapReducerWithFormStateUpdate(
    reducer,
    s => s.form,
    validateDetailsData
)

export function detailsReducer(state: any | undefined, action: Action) {
    return editDetailsDataFormState(state, action);
}
